import React, { useEffect, useState } from "react";
import apiService from "../services/apiService";
import BC from "./Breadcrumb";
import Bdg from "../component/Badge";
import ExamPills from "./ExamPills";
import SB from "../component/SearchBox";

const SCHOOL_API_URL = "School";

const STUDENT_API_URL =
  "School/getSchoolIdWiseStudentList";

const DISTRICT_API_URL =
  "DistrictMaster/getAllDistrictMasters?includeInActive=true";

const TALUKA_API_URL =
  "TalukaMaster/getAllTalukaMasters?includeInActive=true";

const extractArray = (result) => {
  const candidates = [
    result,
    result?.output,
    result?.Output,
    result?.data,
    result?.Data,
    result?.result,
    result?.Result,
    result?.output?.result,
    result?.Output?.Result,
    result?.output?.data,
    result?.Output?.Data,
    result?.output?.items,
    result?.Output?.Items,
    result?.output?.students,
    result?.Output?.Students,
    result?.output?.studentList,
    result?.Output?.StudentList,
    result?.students,
    result?.Students,
    result?.studentList,
    result?.StudentList,
    result?.items,
    result?.Items
  ];

  const arrayValue = candidates.find(Array.isArray);

  return arrayValue ?? [];
};

export default function View({
  school,
  onBack
}) {
  const [q, setQ] = useState("");

  const [schoolDetails, setSchoolDetails] =
    useState(null);

  const [districts, setDistricts] =
    useState([]);

  const [talukas, setTalukas] =
    useState([]);

  const [loading, setLoading] =
    useState(false);

  const [error, setError] =
    useState("");

  // Student states
  const [studentList, setStudentList] =
    useState([]);

  const [studentLoading, setStudentLoading] =
    useState(false);

  const [studentError, setStudentError] =
    useState("");

  // ============================
  // School Details API
  // ============================
  useEffect(() => {
    if (!school?.id) {
      setSchoolDetails(null);
      return;
    }

    const loadSchool = async () => {
      try {
        setLoading(true);
        setError("");

        const response = await apiService.get(
          `${SCHOOL_API_URL}/getSchoolById/${school.id}`
        );

        const result = response.data;

        console.log(
          "School API Response:",
          result
        );

        const isSuccess =
          result?.isSuccess ??
          result?.IsSuccess ??
          true;

        if (isSuccess === false) {
          throw new Error(
            result?.failureReason ??
            result?.FailureReason ??
            "Failed to load school"
          );
        }

        const schoolData =
          result?.output ??
          result?.Output ??
          result?.data ??
          result?.Data ??
          result;

        console.log(
          "School Data:",
          schoolData
        );

        setSchoolDetails(
          schoolData
        );
      } catch (err) {
        console.error(
          "Load School Error:",
          err
        );

        setSchoolDetails(null);

        setError(
          "Unable to load school details."
        );
      } finally {
        setLoading(false);
      }
    };

    loadSchool();
  }, [school?.id]);

  // ============================
  // Student Details API
  // ============================
  useEffect(() => {
    if (!school?.id) {
      setStudentList([]);
      return;
    }

    const loadStudents = async () => {
      try {
        setStudentLoading(true);
        setStudentError("");

        const response = await apiService.get(
          STUDENT_API_URL,
          {
            Id: school.id,
          }
        );

        const result = response.data;

        console.log(
          "Student API Response:",
          result
        );

        const isSuccess =
          result?.isSuccess ??
          result?.IsSuccess ??
          true;

        if (isSuccess === false) {
          throw new Error(
            result?.failureReason ??
            result?.FailureReason ??
            "Failed to load students"
          );
        }

        const data =
          extractArray(result);

        console.log(
          "Student List:",
          data
        );

        setStudentList(data);
      } catch (err) {
        console.error(
          "Load Students Error:",
          err
        );

        setStudentList([]);

        setStudentError(
          "Unable to load student details."
        );
      } finally {
        setStudentLoading(false);
      }
    };

    loadStudents();
  }, [school?.id]);

  // ============================
  // District API
  // ============================
  useEffect(() => {
    const loadDistricts = async () => {
      try {
        const response = await apiService.get(
          DISTRICT_API_URL
        );

        const result = response.data;

        const data =
          extractArray(result);

        setDistricts(data);
      } catch (err) {
        console.error(
          "District Error:",
          err
        );

        setDistricts([]);
      }
    };

    loadDistricts();
  }, []);

  // ============================
  // Taluka API
  // ============================
  useEffect(() => {
    const loadTalukas = async () => {
      try {
        const response = await apiService.get(
          TALUKA_API_URL
        );

        const result = response.data;

        const data =
          extractArray(result);

        setTalukas(data);
      } catch (err) {
        console.error(
          "Taluka Error:",
          err
        );

        setTalukas([]);
      }
    };

    loadTalukas();
  }, []);

  // ============================
  // Get District Name
  // ============================
  const getDistrictName = (
    districtId
  ) => {
    if (!districtId) {
      return "-";
    }

    const district =
      districts.find(
        (item) =>
          Number(
            item?.id ??
            item?.Id ??
            item?.districtId ??
            item?.DistrictId ??
            item?.districtMasterId ??
            item?.DistrictMasterId
          ) ===
          Number(districtId)
      );

    return (
      district?.districtName ??
      district?.DistrictName ??
      district?.districtMasterName ??
      district?.DistrictMasterName ??
      district?.name ??
      district?.Name ??
      "-"
    );
  };

  // ============================
  // Get Taluka Name
  // ============================
  const getTalukaName = (
    talukaId
  ) => {
    if (!talukaId) {
      return "-";
    }

    const taluka =
      talukas.find(
        (item) =>
          Number(
            item?.id ??
            item?.Id ??
            item?.talukaId ??
            item?.TalukaId ??
            item?.talukaMasterId ??
            item?.TalukaMasterId
          ) ===
          Number(talukaId)
      );

    return (
      taluka?.talukaName ??
      taluka?.TalukaName ??
      taluka?.talukaMasterName ??
      taluka?.TalukaMasterName ??
      taluka?.name ??
      taluka?.Name ??
      "-"
    );
  };

  const schoolIsActive =
    schoolDetails?.isActive ??
    schoolDetails?.IsActive ??
    false;

  // ============================
  // Search Student
  // ============================
  const filtered =
    studentList.filter((s) => {
      const firstName =
        s?.firstName ??
        s?.FirstName ??
        "";

      const lastName =
        s?.lastName ??
        s?.LastName ??
        "";

      const generatedFullName =
        `${firstName} ${lastName}`.trim();

      const fullName =
        s?.studentFullName ??
        s?.StudentFullName ??
        s?.fullName ??
        s?.FullName ??
        s?.studentName ??
        s?.StudentName ??
        s?.name ??
        s?.Name ??
        (generatedFullName || "-");

      const rollNumber =
        s?.rollNumber ??
        s?.RollNumber ??
        s?.rollNo ??
        s?.RollNo ??
        "";

      const searchText = [
        fullName,
        rollNumber
      ]
        .filter(Boolean)
        .join(" ")
        .toLowerCase();

      return searchText.includes(
        q.trim().toLowerCase()
      );
    });

  // ============================
  // Main Loading
  // ============================
  if (loading) {
    return (
      <>
        <BC
          items={[
            "Schools",
            `${school?.schoolName ||
            ""
            } — Students`
          ]}
          onBack={onBack}
        />

        <div
          className="card"
          style={{
            padding: 30,
            textAlign: "center"
          }}
        >
          Loading school details...
        </div>
      </>
    );
  }

  // ============================
  // Main Error
  // ============================
  if (error) {
    return (
      <>
        <BC
          items={[
            "Schools",
            "School Details"
          ]}
          onBack={onBack}
        />

        <div
          className="card"
          style={{
            padding: 30,
            textAlign: "center",
            color: "#dc2626"
          }}
        >
          {error}
        </div>
      </>
    );
  }

  return (
    <>
      <BC
        items={[
          "Schools",
          `${schoolDetails?.schoolName ||
          school?.schoolName ||
          ""
          } — Students`
        ]}
        onBack={onBack}
      />

      {/* Search */}
      <div className="toolbar">
        <SB
          value={q}
          onChange={setQ}
          placeholder="Search students…"
        />
      </div>

      {/* ============================
          School Details
      ============================ */}

      <div
        style={{
          fontWeight: 700,
          fontSize: 15,
          marginBottom: 10
        }}
      >
        School Details
      </div>

      <div
        className="card"
        style={{
          marginBottom: 16
        }}
      >
        <div className="tw">
          <table>
            <thead>
              <tr>
                <th>
                  School Name
                </th>

                <th>
                  State
                </th>

                <th>
                  District
                </th>

                <th>
                  Taluka
                </th>

                <th>
                  School Address
                </th>

                <th>
                  Phone
                </th>

                <th>
                  Status
                </th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>
                  <span className="tdb">
                    {schoolDetails
                      ?.schoolName ||
                      "-"}
                  </span>
                </td>

                <td>
                  Maharashtra
                </td>

                <td>
                  {getDistrictName(
                    schoolDetails?.districtId ??
                    schoolDetails
                      ?.DistrictId
                  )}
                </td>

                <td>
                  {getTalukaName(
                    schoolDetails?.talukaId ??
                    schoolDetails
                      ?.TalukaId
                  )}
                </td>

                <td>
                  {schoolDetails
                    ?.address ??
                    schoolDetails
                      ?.Address ??
                    "-"}
                </td>

                <td>
                  {schoolDetails
                    ?.phoneNumber ??
                    schoolDetails
                      ?.PhoneNumber ??
                    "-"}
                </td>

                <td>
                  <Bdg
                    type={
                      schoolIsActive
                        ? "green"
                        : "yellow"
                    }
                    label={
                      schoolIsActive
                        ? "Active"
                        : "Inactive"
                    }
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      {/* ============================
          Student Details
      ============================ */}

      <div
        style={{
          fontWeight: 700,
          fontSize: 15,
          marginBottom: 10
        }}
      >
        Student Details
      </div>

      <div className="card">
        <div className="tw">
          <table>
            <thead>
              <tr>
                <th>
                  Student Name
                </th>

                <th>
                  Class
                </th>

                <th>
                  Exams
                </th>

                <th>
                  Status
                </th>
              </tr>
            </thead>

            <tbody>
              {studentLoading ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      textAlign:
                        "center",
                      padding:
                        "28px",
                      color:
                        "var(--t3)"
                    }}
                  >
                    Loading students...
                  </td>
                </tr>
              ) : studentError ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      textAlign:
                        "center",
                      padding:
                        "28px",
                      color:
                        "#dc2626"
                    }}
                  >
                    {studentError}
                  </td>
                </tr>
              ) : filtered.length ===
                0 ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{
                      textAlign:
                        "center",
                      padding:
                        "28px",
                      color:
                        "var(--t3)"
                    }}
                  >
                    🎓 No students found
                  </td>
                </tr>
              ) : (
                filtered.map(
                  (s, i) => {
                    const firstName =
                      s?.firstName ??
                      s?.FirstName ??
                      "";

                    const lastName =
                      s?.lastName ??
                      s?.LastName ??
                      "";

                    const generatedFullName =
                      `${firstName} ${lastName}`.trim();

                    const fullName =
                      s?.fullName ??
                      s?.FullName ??
                      s?.studentFullName ??
                      s?.StudentName ??
                      s?.name ??
                      s?.Name ??
                      (generatedFullName ||
                        "-");

                    const classValue =
                      s?.standardName ??
                      s?.Class ??
                      s?.className ??
                      s?.ClassName ??
                      s?.standard ??
                      s?.Standard ??
                      "-";

                    const exams =
                      s?.examName
                        ? [s.examName]
                        : s?.ExamName
                          ? [s.ExamName]
                          : Array.isArray(s?.exams)
                            ? s.exams
                            : Array.isArray(s?.Exams)
                              ? s.Exams
                              : [];

                    const status =
                      s?.status ??
                      s?.Status ??
                      s?.paymentStatus ??
                      s?.PaymentStatus ??
                      "Pending";

                    const isPaid =
                      String(status).toLowerCase() === "paid";


                    return (
                      <tr
                        key={
                          s?.id ??
                          s?.Id ??
                          s?.studentId ??
                          s?.StudentId ??
                          `${fullName}-${i}`
                        }
                      >
                        {/* Student Name */}
                        <td>
                          <div
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                              gap: 8
                            }}
                          >
                            <div
                              className="av"
                              style={{
                                width: 26,
                                height: 26,
                                fontSize:
                                  10,
                                background: `hsl(${i *
                                  55 +
                                  190
                                  },58%,52%)`
                              }}
                            >
                              {fullName?.[0]
                                ?.toUpperCase() ||
                                "S"}
                            </div>

                            <span className="tdb">
                              {fullName}
                            </span>
                          </div>
                        </td>

                        {/* Class */}
                        <td>
                          <Bdg
                            type="blue"
                            label={`Class ${classValue}`}
                          />
                        </td>

                        {/* Exams */}
                        <td>
                          <ExamPills
                            exams={
                              exams
                            }
                          />
                        </td>

                        {/* Status */}
                        <td>
                          <Bdg
                            type={isPaid ? "green" : "yellow"}
                            label={isPaid ? "Paid" : "Pending"}
                          />
                        </td>
                      </tr>
                    );
                  }
                )
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}